import { ComponentProps, ReactElement } from "react";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_SATURATED } from "@/styles/colorsJS";
import { twCn } from "@/styles/utils";

interface Props extends ComponentProps<"ul"> {
  textList: ReactElement[];
}

export function TagsList({ textList, className }: Props) {
  return (
    <ul className={twCn("flex flex-wrap gap-4", className)}>
      {textList.map((text, index) => (
        <li key={index} className="bg-brand-bg rounded-[40px] px-4 py-2">
          <Typography type="bodyBold" color={BRAND_SATURATED}>
            {text}
          </Typography>
        </li>
      ))}
    </ul>
  );
}
